import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Graphic Design Foundations & Visual Communication Basics",
    description:
      "Introduction to Graphic Design,Its role in digital and print media, Principles of design: balance contrast hierarchy alignment, Understanding color theory & psychology, Composition layout & visual storytelling, Identifying design trends and styles",
  },
  {
    title: "Typography, Fonts & Text Styling Techniques",
    description:
      "Type anatomy: serif sans-serif display fonts, Pairing fonts effectively, Tracking kerning & leading, Using text to communicate emotions & brand identity, Professional typography practices for digital & print",
  },
  {
    title: "Adobe Photoshop & Image Manipulation Mastery",
    description:
      "Interface tools & workspace shortcuts, Photo editing retouching & color correction, Removing backgrounds & manipulating images, Creating social media graphics posters & banners, Working with layers masks & smart objects",
  },
  {
    title: "Adobe Illustrator & Vector Graphic Design",
    description:
      "Creating vector logos icons & illustrations, Pen tool mastery for shapes & curves, Branding mascots & scalable designs, Creating corporate assets like business cards & flyers, Exporting vector graphics for print & Web",
  },
  {
    title: "Layout Design, Grids & Branding Systems (Adobe InDesign)",
    description:
      "Multi-page document design, Magazine brochure & catalogue layouts, Grid systems & spacing rules, Corporate identity & brand guidelines, Preparing print-ready files",
  },
  {
    title: "Digital Illustration, Concept Art & Creative Drawing",
    description:
      "Sketching & digital drawing fundamentals, Character design & storytelling, Brushes textures & shading, Creating concept art for brands games & animation, Enhancing creativity with Illustrator/Procreate",
  },
  {
    title: "Social Media Design, UI Aesthetics & Creative Ads",
    description:
      "Designing for Instagram Facebook LinkedIn YouTube, Carousel posts thumbnails reels covers ads, Visual hierarchy for high-engagement posts, Mood boards & brand templates, Creating on-brand digital visual assets",
  },
  {
    title: "Motion Graphics, Animation & Video Editing (Basic)",
    description:
      "Intro to After Effects / Premiere Pro, Creating motion text & kinetic typography, Logo animation & simple transitions, Designing animated social posts, Exporting high-quality video assets",
  },
  {
    title: "Project Workflow, Creative Thinking & Client Handling",
    description:
      "Understanding client briefs, Brainstorming + moodboard creation, Revisions feedback & professional communication, File organization & delivery formats, Building a strong design process & workflow",
  },
  {
    title: "Capstone Design Project & Career Launchpad",
    description:
      "Create a full branding package (logo posters social posts brochure), Portfolio creation with professional mockups, Behance/Dribbble portfolio setup, Resume & freelance profile building, Interview prep for Graphic Designer Illustrator Creative Artist roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
